import { render, staticRenderFns } from "./MessageCompose.vue?vue&type=template&id=1e57ee4d&scoped=true&"
import script from "./MessageCompose.vue?vue&type=script&lang=js&"
export * from "./MessageCompose.vue?vue&type=script&lang=js&"
import style0 from "./MessageCompose.vue?vue&type=style&index=0&id=1e57ee4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e57ee4d",
  null
  
)

export default component.exports